import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "center-wrapper" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { style: {"margin-bottom":"10px"} }
const _hoisted_4 = { class: "master-table" }
const _hoisted_5 = { style: {"min-width":"160px"} }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick", "disabled"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "block-label" }
const _hoisted_11 = {
  class: "inline-or-block",
  style: {"padding-left":"4px"}
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { style: {"padding-top":"50px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JapaneseInput = _resolveComponent("JapaneseInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.listMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "link-button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showNewInput && _ctx.showNewInput(...args)))
            }, "新規作成")
          ]),
          _createElementVNode("table", _hoisted_4, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _cache[4] || (_cache[4] = _createElementVNode("th", { class: "edit-remove-column" }, null, -1)),
                _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.masterName), 1)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_ctx.master.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [...(_cache[5] || (_cache[5] = [
                    _createElementVNode("td", {
                      colspan: "10",
                      class: "no-data"
                    }, " データがありません ", -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.master, (row) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: "stripe-tr",
                  key: row.id
                }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("button", {
                      class: "link-button edit-remove-link",
                      onClick: ($event: any) => (_ctx.showEditInput(row))
                    }, "編集", 8, _hoisted_7),
                    _createElementVNode("button", {
                      class: "link-button edit-remove-link",
                      onClick: ($event: any) => (_ctx.remove(row)),
                      disabled: !row.canDelete
                    }, "削除", 8, _hoisted_8)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(row.text), 1)
                ]))
              }), 128))
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.masterName), 1),
          _createVNode(_component_JapaneseInput, {
            id: "masterInput",
            onKeydown: _withKeys(_ctx.save, ["enter"]),
            modelValue: _ctx.editText,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editText) = $event))
          }, null, 8, ["onKeydown", "modelValue"]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              class: "btn-primary",
              disabled: !_ctx.editText,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
            }, "保存", 8, _hoisted_12)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              class: "link-button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.listMode = true))
            }, "一覧へ戻る")
          ])
        ]))
  ]))
}